import React, { Component } from 'react'
import { Card, Icon } from 'semantic-ui-react'
import './PlansSection.less'

export class PlansSection extends Component {
    render() {
        return (
            <div className='plan-selection-container'>
                <Card.Group>
                    {this.props.plans.map(sp => <Card onClick={() => this.props.setSelectedPlan(sp.plan)} className={`${sp.plan.planID == this.props.selectedPlan.planID ? 'selected' : sp.plan.trialDays > 0 ? 'trial' : ''}`}>
                        <Card.Content>
                            <Card.Header>{sp.plan.planName} {sp.plan.isPrivate ? <Icon name='star' /> : ''}</Card.Header>
                            <Card.Meta>Plan Type: {sp.plan.planType}</Card.Meta>
                            <Card.Description>
                                <p>Price: {sp.plan.price}</p>
                                {Number(sp.plan.referralFee) ? <p>Referral Fee: ${sp.plan.referralFee || 0}</p> : <p>Commission: {sp.plan.commission || 0}%</p>}
                                {sp.plan.trialDays > 0 && <p>Trial Days: {sp.plan.trialDays || 0}</p>}
                            </Card.Description>
                        </Card.Content>
                    </Card>)}
                </Card.Group>
            </div >
        )
    }
}

export default PlansSection
